import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import useStyles from './styles';
import MessageOutgoingActions from '../../../../redux/reducers/message_outgoing_reducer/actions';
import { ReducerKeys } from '../../../../redux/reducers';
import { getState } from 'redux/store';
import { StateStatus } from '../../../../redux/utils/common';

interface IProps {
  rowIndex: number;
  // data: string;
  message_outgoing_id: string | number;
  error: string;
}

export default function ActionsBlock(props: IProps) {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClick = async (type: 'view' | 'error') => {
    let header = type === 'view' ? 'XML Content' : 'XML Error';
    let body = type === 'view' ? props.message_outgoing_id : props.error;

    if (type === 'view') {
      await dispatch(
        MessageOutgoingActions.fetchMessageOutgoingXmlAction({
          messageId: `${props.message_outgoing_id}`,
        })
      );
      const xmlMessage = getState(
        ReducerKeys.MESSAGE_OUTGOING_REDUCER
      ).xmlMessage;
      // console.log(xmlMessage);
      if (
        xmlMessage.status === StateStatus.Success &&
        xmlMessage.data !== null
      ) {
        body = xmlMessage.data;
      } else {
        body = `XML of Outgoing Message with ID: ${props.message_outgoing_id} not found`;
      }
    }
    dispatch(
      ModalActions.openModalAction({
        modalID: ModalIDs.MODAL_MESSAGE_OUTGOING_VIEW,
        params: { header, body },
      })
    );
  };

  return (
    <div>
      {props.message_outgoing_id && (
        <Button
          // variant="outlined"
          // className={classes.viewButton}
          onClick={() => handleClick('view')}
        >
          View
        </Button>
      )}
      {props.error && (
        <Button
          // variant="outlined"
          // className={classes.viewButton}
          className={classes.textRedColor}
          onClick={() => handleClick('error')}
        >
          Error
        </Button>
      )}
    </div>
  );
}
